import { formColors } from "../../shared/colors";

interface TextAreaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: boolean;
  disabled?: boolean;
}

export function TextArea({
  label,
  error = false,
  disabled = false,
  className = "",
  ...props
}: TextAreaProps) {
  const getTextAreaClasses = () => {
    const baseClasses =
      "w-full px-3 py-2 rounded-md shadow-xs transition-colors duration-200 resize-vertical focus:outline-hidden focus:ring-2 caret-primary";

    if (disabled) {
      return `${baseClasses} ${formColors.textarea.disabled}`;
    }

    if (error) {
      return `${baseClasses} ${formColors.textarea.error} dark:text-white`;
    }

    return `${baseClasses} ${formColors.textarea.base} ${formColors.textarea.focus} dark:text-white`;
  };

  return (
    <div>
      {label && (
        <label className="block text-sm font-medium text-text-primary dark:text-bodydark mb-2">
          {label}
        </label>
      )}
      <textarea
        className={`${getTextAreaClasses()} dark:bg-boxdark dark:border-strokedark ${className}`}
        disabled={disabled}
        {...props}
      />
    </div>
  );
}
